import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../../base/hooks';
import { ReactComponent as ConfirmPhoneIcon } from '../../../../../assets/img/confirm-phone-icon.svg';
import { Confirmation as ConfirmationComponent } from '../../../../../components/Confirmation';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';
import { workerAppActions } from '../../../../../redux/slices/workerAppSlice';
import { SettingsRoutes } from '../../../routes';

import '../styles.scss';

export const Confirmation = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {
        fields: { phone, smsCode = '' },
        errors,
    } = useAppSelector((state) => state.workerAppSettings.createLogin);
    const settingsRoutes = useRoutesWithLang<typeof SettingsRoutes>(SettingsRoutes);

    const verificationCodeChangeHandler = (value: unknown) => {
        dispatch(
            settingsActions.setCreateLoginField({
                id: 'smsCode',
                value,
            }),
        );
    };

    const submitResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(workerAppActions.sendConfirmationCode(phone, recaptchaToken, callback));
    };

    const successCallback = () => navigate(settingsRoutes.Settings);

    const submitCode = () => {
        dispatch(settingsActions.createLoginSubmit(successCallback));
    };

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(settingsActions.createLoginSubmitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    return (
        <div className='create-login'>
            <div className='create-login__confirmation'>
                <ConfirmPhoneIcon className='create-login__icon' />

                <h2 className='create-login__confirmation-title'>{__t('Подтвердите телефон')}</h2>
                <ConfirmationComponent
                    codeValue={smsCode}
                    confirmationMethod={'phone'}
                    text={
                        <>
                            {__t('Мы отправили код подтверждения на номер')} <br />
                            <strong>{phone}</strong>
                        </>
                    }
                    codeErrors={errors?.smsCode}
                    changeConfirmationValueErrors={errors?.phone}
                    updateModalText={__t('На которий мы отправим код для подтверждения')}
                    verificationCodeChangeHandler={verificationCodeChangeHandler}
                    submitCode={submitCode}
                    submitResendCode={submitResendCode}
                    submitChangeConfirmationValue={submitChangeConfirmationValue}
                />
            </div>
        </div>
    );
};
